const teachers = {
  pageTitle: 'Teachers',
  // Table columns
  number: '#',
  teacher: 'Teacher',
  role: 'Role',
  class: 'Class',
  students: 'Students',
  joiningDate: 'Joining Date',
  contact: 'Contact',
  status: 'Status',
  // Status
  active: 'Active',
  onLeave: 'On Leave',
  inactive: 'Inactive',
  // Filters
  searchTeachers: 'Search teachers...',
  allClasses: 'All Classes',
  allRoles: 'All Roles',
  filtered: 'Filtered',
  // Onboarding modal
  step1Label: 'Profile',
  step2Label: 'Assignment',
  step1Title: 'Teacher Profile',
  step2Title: 'Class & Assignment Details',
  onboardTeacher: 'Onboard Teacher',
  enterFullName: "Enter teacher's full name",
  selectRole: 'Select role',
  fullResidentialAddress: 'Full residential address',
  selectClassSection: 'Select class section',
  profileSummary: 'Profile Summary',
  assignmentSummaryPrefix: 'Assigned to',
  joiningPrefix: 'Joining',
  completeFieldsPrompt: 'Complete the fields above to see the assignment summary.',
  // Detail modal
  editTeacher: 'Edit Teacher',
  profileInformation: 'Profile Information',
  assignmentDetails: 'Assignment Details',
  studentsAssigned: '{{count}} student assigned',
  studentsAssignedPlural: '{{count}} students assigned',
  teacherHasStudents: 'This teacher has {{count}} student in {{className}}',
  teacherHasStudentsPlural: 'This teacher has {{count}} students in {{className}}',
  viewStudents: 'View Students',
  noStudentsEnrolled: 'No students enrolled yet',
  saveChanges: 'Save Changes',
  deactivate: 'Deactivate',
  // Reactivation
  reactivateTeacher: 'Reactivate teacher',
  reactivateConfirm: 'Reactivate {{name}}?',
  // Empty state
  noTeachersFound: 'No teachers found',
};

export default teachers;